import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class GenderFuncService {
  constructor(private http: HttpClient, private api: AppConfig) {
  }

  genderTypes() {
    return this.http.get(this.api.baseUrl + '/genderType/genderTypes', this.api.jsonTokenHeaders);
  }

  findAvailable() {
    return this.http.get(this.api.baseUrl + '/genderType/findAvailable' , this.api.jsonTokenHeaders);
  }

  deleteGenderType(id) {
    return this.http.delete(this.api.baseUrl + '/genderType/deleteGenderType?id=' + id , this.api.jsonTokenHeaders);
  }

  addGenderType(data) {
    return this.http.post(this.api.baseUrl + '/genderType/addGenderType' , data , this.api.formDataHeaders);
  }

  addUserConnection(data) {
    return this.http.post(this.api.baseUrl + '/userConnection/addUserConnection' , data , this.api.formDataHeaders);
  }

  userConnections(id) {
    return this.http.get(this.api.baseUrl + '/userConnection/userConnections?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteUserConnections(id) {
    return this.http.delete(this.api.baseUrl + '/userConnection/deleteUserConnection?id=' + id , this.api.jsonTokenHeaders);
  }
}
